import loadable from '@loadable/component';
import Title from '../components/Title';
import IntegrationPageSection from './IntegrationPageSection';
import OverviewWelcomeMessage from './OverviewPage/OverviewWelcomeMessage';
import OverviewBenefits from './OverviewPage/OverviewBenefits';
import OverviewPaymentMethods from './OverviewPage/OverviewPaymentMethods';
import AlertBox from '../components/AlertBox';
import ClickableCardsSection from './OverviewPage/ClickableCardsSection';
import ImageListWithNumberedCard from './OverviewPage/ImageListWithNumberedCard';
import IntroSection from './GetStarted/IntroSection/IntroSection';
import PaymentMethods from './GetStarted/PaymentMethods/PaymentMethods';
import CaptionedImagesRow from './GetStarted/CaptionedImagesRow';
import SetUpInfo from './GetStarted/SetUpInfo/SetUpInfo';
import NextSteps from './GetStarted/NextSteps/NextSteps';
import HtmlContent from './NoCode/HtmlContent';
import TabsSection from './NoCode/TabsSection';
import HtmlList from './NoCode/HtmlList';
import Divider from '../components/Divider';
import ImageDescriptionList from './GetStarted/ImageDescriptionList';
import NumberedList from './GetStarted/NumberedList';
import CountrySelector from './BNPL/CountrySelector';
import CustomizePageHeader from './Customize/CustomizePageHeader';
import CustomizeCardsSection from './Customize/CustomizeCardsSection';
import MerchantConfigurator from '@MerchantConfigurator/index.tsx';
import HtmlContentBadge from '../components/HtmlContentBadge';
import CodeSection from './Customize/CustomizeCodeSection';
import BnplControlPanel from './BNPL/BnplControlPanel';
import DynamicTabs from '../components/DynamicTabs';
import MarkdownContent from '../components/Text/MarkdownText/MarkdownContent';
import ButtonRenderer from '../components/ButtonRenderer';
import CardsList from '../components/CardsList';

const componentMap = new Map();
componentMap.set('titletag', Title);
componentMap.set('clientSDKIntegrationSection', IntegrationPageSection);

componentMap.set(
  'HtmlPageSection',
  loadable(() => import('./IntegrationPageSection/HtmlPageSection'))
);

componentMap.set('DividingLine', Divider);
componentMap.set('dynamicTabs', DynamicTabs);
componentMap.set('markdownContent', MarkdownContent);
componentMap.set('buttonRender', ButtonRenderer);
componentMap.set('cardsList', CardsList);

// Overview Page
componentMap.set('overviewWelcomeMessage', OverviewWelcomeMessage);
componentMap.set('overviewBenefits', OverviewBenefits);
componentMap.set('checkoutPaymentMethods', OverviewPaymentMethods);
componentMap.set('alertBox', AlertBox);
componentMap.set('clickableCardsSection', ClickableCardsSection);
componentMap.set('imageListWithNumberedCard', ImageListWithNumberedCard);

// No Code Page
componentMap.set('htmlContent', HtmlContent);
componentMap.set('htmlList', HtmlList);
componentMap.set('tabsSection', TabsSection);

// Get Started Page
componentMap.set('introSection', IntroSection);
componentMap.set('paymentMethods', PaymentMethods);
componentMap.set('captionedImagesRow', CaptionedImagesRow);
componentMap.set('setUpInfo', SetUpInfo);
componentMap.set('nextSteps', NextSteps);
componentMap.set('imageDescriptionList', ImageDescriptionList);
componentMap.set('numberedList', NumberedList);
// BNPL Page
componentMap.set('countrySelector', CountrySelector);
componentMap.set('htmlContentBadge', HtmlContentBadge);
componentMap.set('codeSection', CodeSection);
componentMap.set('bnplControlPanel', BnplControlPanel);

// Customize page
componentMap.set(
  'customizePageContent',
  loadable(() => import('./Customize'))
);
componentMap.set('customizePageHeader', CustomizePageHeader);
componentMap.set('customizeCardsSection', CustomizeCardsSection);
componentMap.set('merchantConfigurator', MerchantConfigurator);

export default componentMap;
